import { MdClose } from "react-icons/md"
import "./styles.scss"

export const ChipComponent = ({ color, onRemove, label }) => {
  return (
    <div className="chip-component-container">
      {label &&
        label.length ?
        label.map((item) => (
          <ChipComponentItem
            {...{
              color: color || item?.color,
              data: item,
            }}
            onRemove={!item?.removeIcon && (() => onRemove(item?.value, item?.type))}
          />
        )) : <></>}
    </div>
  )
}

const ChipComponentItem = ({ color, onRemove, data }) => {

  const labelText = typeof data.value === 'number'
  ? ""
  : data.type === "year"
  ? "Data Inicial"
  : data.type === "yearReference"
  ? "Data de Referência"
  : "";

  return (
    <div className="chip-component-item-container">
    <span className="chip-component-item-label">{labelText}</span>
    <div
      className={`chip-component-item chip-component-item--${color || "primary"}`}
      key={data.value}>
      <span className="chip-item-text">{data.value}</span>
      {!data?.removeIcon && onRemove && (
        <button onClick={onRemove} className="chip-item-button">
          <MdClose size={16} color="#c80e00" />
        </button>
      )}
    </div></div>
  )
}
